﻿export enum Role {
    Undefined = 0,
    Admin = 1 << 0, 
    CSR = 1 << 1,
    Rep = 1 << 2,
    Buyer = 1 << 3
}